let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3vk3N")).then(() => parcelRequire('B195q'));